var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lp lp-create"},[_c('f-header-lp-create'),_vm._v(" "),_c('main',{staticClass:"main"},[_c('nuxt')],1),_vm._v(" "),_c('f-footer-lp-create')],1)}
var staticRenderFns = []

export { render, staticRenderFns }